module.exports = __webpack_public_path__ + "static/media/img-devteam-page-mobile@2x.d7acef46.png";